export default import.meta.ROLLDOWN_FILE_URL_p1VtH0uA1FwflypdhN7QNg